<!-- /src/components/common/AskCarrAi/AskCarrAiPanel.vue -->
<!-- "Ask CARR AI" homepage panel (spec: Ask CARR AI - 1.0-F comp, 2026-09-24).
     Right-rail panel, open by default on the dashboard. Copy verbatim from
     comp. Submit hands the question to the AI portal via ?q= (handoff
     contract to be implemented portal-side). URL is config-driven so the
     upcoming domain flip is a config change, not a code hunt. -->
<template>
  <aside class="acai" aria-label="Ask CARR AI">
    <h2 class="acai__heading">Ask CARR AI</h2>
    <p class="acai__helper">
      Get quick, sourced answers on transactions, negotiations,
      vertical-specific needs, and vendors. Just ask. (Additional login
      may be required.)
    </p>
    <form @submit.prevent="submitQuestion">
      <textarea
        ref="question"
        v-model="question"
        class="acai__input"
        placeholder="What would you like to know?"
        aria-label="Ask CARR AI"
      ></textarea>
      <button type="submit" class="acai__submit">{{ submitLabel }}</button>
    </form>
  </aside>
</template>

<script>
export default {
  name: 'ask-carr-ai-panel',

  data() {
    return {
      question: '',
      submitting: false,
      // Portal address — placeholder subdomain until CARR decides the real
      // one (asked Nate 9/24). Override via VUE_APP_AI_PORTAL_URL at build.
      portalBaseUrl:
        process.env.VUE_APP_AI_PORTAL_URL || 'https://ai.carr.us',
    }
  },

  computed: {
    submitLabel() {
      return this.submitting ? 'Loading…' : 'ASK THE AI →'
    },
  },

  methods: {
    submitQuestion() {
      const q = this.question.trim()
      if (!q) {
        // Empty question: focus the textarea (the submit button has no
        // disabled state, so the button stays visually enabled).
        this.$refs.question.focus()
        return
      }
      this.submitting = true
      window.location.href =
        this.portalBaseUrl.replace(/\/$/, '') + '/?q=' + encodeURIComponent(q)
    },
  },
}
</script>

<style scoped>
.acai {
  /* Layout (placement/width) is owned by the dashboard grid; the
     component styles only its own look. Flex column so the human-help
     block can align to the end (bottom) of the stretched panel. */
  display: flex;
  flex-direction: column;
  height: 100%;
  box-sizing: border-box;
  padding: 28px 26px;
  border-radius: 8px;
  background: rgba(35, 35, 35, 0.78);
  color: #fff;
  font-family: inherit;
}
.acai__heading {
  margin: 0 0 12px;
  color: #fff;
  font-size: 34px;
  font-weight: 600;
  line-height: 1.1;
}
.acai__helper {
  margin: 0 0 16px;
  color: #fff;
  font-size: 13px;
  font-style: italic;
  line-height: 1.5;
}
.acai__input {
  display: block;
  width: 100%;
  height: 120px;
  box-sizing: border-box;
  margin-bottom: 14px;
  padding: 14px;
  border: 0;
  border-radius: 4px;
  background: #fff;
  color: #1a1a1a;
  font-family: inherit;
  font-size: 15px;
  resize: none;
}
.acai__input::placeholder {
  color: #8a8a8a;
}
.acai__submit {
  display: block;
  width: 100%;
  height: 44px;
  border: 0;
  border-radius: 4px;
  background: #c4622d; /* CARR brand orange (comp-sampled) */
  color: #fff;
  font-weight: 700;
  font-size: 15px;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  cursor: pointer;
}
.acai__submit:hover {
  background: #d06e38;
}
/* Narrow-screen visibility is controlled by the dashboard grid
   (.dashboard-ai-panel) pending the mobile drawer treatment. */
</style>
